let add_d_shapes_list = ['asscher','cushion','emerald','marquise','oval','pear','princess','radiant','round','trilliant','heart','trillion']


let s_nav = document.querySelector('#SiteNav')
let s_nav_mobile = document.querySelector('#MobileNav')
if(s_nav){
    addDiamondShapesToNav()
}

if(s_nav_mobile){
    addDiamondShapesToNavMobile()
}

function addDiamondShapesToNavMobile(){
    let site_nav_dds = Array.from(s_nav_mobile.querySelectorAll('.mobile-nav__item'))
    
    site_nav_dds.forEach(dd=>{
        let lbl = dd.querySelector('.mobile-nav__label')
        if(lbl){
            if(lbl.innerText.toLowerCase().trim() == 'shop by shape'){
                let site_nav_submenus = Array.from(dd.querySelectorAll('.mobile-nav__item'))


                site_nav_submenus.forEach(sub=>{
                    let sub_links = Array.from(sub.querySelectorAll('.mobile-nav__sublist-link'))
                    
                    sub_links.forEach(sub_link=>{
                        let sub_link_name = sub_link.innerText.toLowerCase().trim()
                        
                        add_d_shapes_list.forEach(shape=>{
                            if(sub_link_name.includes(shape)){
                                let img = document.createElement('img')

                                img.src = 'https://cdn.shopify.com/s/files/1/0023/2878/9049/files/'+ shape +'.png'
                                img.style.height = '25px'
                                img.style.position = 'absolute'
                                img.style.left = '50%'
                                img.style.transform = 'translateX(-50%)'
        
                                if(sub_link.querySelector('img') == null){
                                    //sub_link.append(img)
                                    let span = sub_link.querySelector('span')

                                    let img_container = document.createElement('div')
                                        img_container.style.width = '30px'
                                        img_container.style.height = '25px'
                                        img_container.style.position = 'absolute'
                                        img_container.style.textAlign = 'center'
                                        img_container.append(img)
                                    sub_link.insertBefore(img_container, span)
                                    span.style.marginLeft = '37px'
                                }
                                
                            }
                        })
                        
                        
                    })
                })

            }

            //design
            if(lbl.innerText.toLowerCase().trim() == 'shop by design'){
                let site_nav_submenus = Array.from(dd.querySelectorAll('.mobile-nav__item'))


                site_nav_submenus.forEach(sub=>{
                    let sub_links = Array.from(sub.querySelectorAll('.mobile-nav__sublist-link'))
                    
                    sub_links.forEach(sub_link=>{
                        let sub_link_name = sub_link.innerText.toLowerCase().trim()
                        
                            if(sub_link_name != 'shop by design'){
                                let img = document.createElement('img')

                                img.src = 'https://cdn.shopify.com/s/files/1/0023/2878/9049/files/lucce_logo_2023_small_b0884c8e-1b18-4d4c-a61d-a62e5cdc5a74.png'
                                img.style.height = '25px'
                                img.style.position = 'absolute'
                                img.style.left = '50%'
                                img.style.transform = 'translateX(-50%)'
        
                                if(sub_link.querySelector('img') == null){
                                    //sub_link.append(img)
                                    let span = sub_link.querySelector('span')

                                    let img_container = document.createElement('div')
                                        img_container.style.width = '30px'
                                        img_container.style.height = '25px'
                                        img_container.style.position = 'absolute'
                                        img_container.style.textAlign = 'center'
                                        img_container.append(img)
                                    sub_link.insertBefore(img_container, span)
                                    span.style.marginLeft = '37px'
                                }
                                
                            }
                        
                        
                    })
                })

            }
        }
    })
}

function addDiamondShapesToNav(){
    let site_nav_dds = Array.from(s_nav.querySelectorAll('.site-nav--has-dropdown'))
    
    site_nav_dds.forEach(dd=>{
        let lbl = dd.querySelector('.site-nav__label')
        if(lbl){
            
            if(lbl.innerText.toLowerCase().trim() == 'shop by shape'){
                let links = Array.from(dd.querySelectorAll('.site-nav__link'))

                links.forEach(link=>{
                    let link_name = link.innerText.toLowerCase().trim()

                    //shape in link
                    add_d_shapes_list.forEach(shape=>{
                        if(link_name.includes(shape)){
                            let img = document.createElement('img')

                            img.src = 'https://cdn.shopify.com/s/files/1/0023/2878/9049/files/'+ shape +'.png'
                            img.style.height = '25px'
                            img.style.position = 'absolute'
                            img.style.left = '50%'
                            img.style.transform = 'translateX(-50%)'
                            //img.style.visibility = 'hidden'

                            let img_container = document.createElement('div')
                            img_container.style.width = '30px'
                            img_container.style.height = '25px'
                            img_container.style.position = 'absolute'
                            img_container.style.textAlign = 'center'
                            img_container.append(img)

                            let span = link.querySelector('span')
                            span.style.marginLeft = '37px'
                            link.insertBefore(img_container,span)
                        }
                    })
                })
            }

            //style
            if(lbl.innerText.toLowerCase().trim() == 'shop by design'){
                let links = Array.from(dd.querySelectorAll('.site-nav__link'))

                links.forEach(link=>{
                    let link_name = link.innerText.toLowerCase().trim()

                    if(link_name != 'shop by design'){

                    //shape in link
                    
                    let img = document.createElement('img')

                    img.src = 'https://cdn.shopify.com/s/files/1/0023/2878/9049/files/lucce_logo_2023_small_b0884c8e-1b18-4d4c-a61d-a62e5cdc5a74.png'
                    img.style.height = '25px'
                    img.style.position = 'absolute'
                    img.style.left = '50%'
                    img.style.transform = 'translateX(-50%)'
                    //img.style.visibility = 'hidden'

                    let img_container = document.createElement('div')
                    img_container.style.width = '30px'
                    img_container.style.height = '25px'
                    img_container.style.position = 'absolute'
                    img_container.style.textAlign = 'center'
                    img_container.append(img)

                    let span = link.querySelector('span')
                    span.style.marginLeft = '37px'
                    link.insertBefore(img_container,span)
                
                    }
                })
            }
        }
    })
}